import { useEffect, useState, useCallback } from 'react'
import { supabase } from '@/lib/supabase'

/**
 * Auth hook compatible with ConvexProviderWithAuth.
 * Provides token fetching and auth state for Convex integration.
 */
export function useSupabaseAuth() {
  // undefined = loading, null = not authenticated, string = authenticated
  const [token, setToken] = useState<string | null | undefined>(undefined)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setToken(session?.access_token ?? null)
    })

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setToken(session?.access_token ?? null)
    })

    return () => subscription.unsubscribe()
  }, [])

  const fetchAccessToken = useCallback(
    async ({ forceRefreshToken }: { forceRefreshToken: boolean }) => {
      if (forceRefreshToken) {
        const {
          data: { session },
        } = await supabase.auth.refreshSession()
        return session?.access_token ?? null
      }
      const {
        data: { session },
      } = await supabase.auth.getSession()
      return session?.access_token ?? null
    },
    []
  )

  return {
    isLoading: token === undefined,
    isAuthenticated: !!token,
    fetchAccessToken,
  }
}
